const API_URL = process.env.REACT_APP_API_URL;

/**
 * Extract the best error message from a ProblemDetail response body, matching the
 * convention used across the other services (flowService, bookingService et al.).
 */
function extractErrorMessage(errorBody, fallback) {
  if (!errorBody) return fallback;
  const detail = errorBody.detail;
  const title = errorBody.title;
  if (detail && title && title !== fallback) {
    return `${title}: ${detail}`;
  }
  return detail || fallback;
}

async function asJsonOrThrow(response, fallback) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(extractErrorMessage(error, fallback));
  }
  return await response.json();
}

/**
 * Client for the welcome-chips API: the WhatsApp "ice breaker" prompts shown to a first-time
 * visitor before they type. GET always re-reads Meta's current prompts (never trusts a past
 * save); PUT validates, wires each chip to a keyword trigger, and writes to Meta.
 */
class WelcomeChipsService {
  /** { chips, metaPrompts, syncStatus: 'IN_SYNC'|'NOT_IN_SYNC'|'NOT_READ', syncedAt, lastError, phoneNumberId } */
  async get(envId, authenticatedFetch) {
    const response = await authenticatedFetch(
      `${API_URL}/api/environments/${envId}/welcome-chips`
    );
    return asJsonOrThrow(response, 'Failed to load welcome chips');
  }

  /** chips: [{ text, flowId }], at most 4. Returns the same status shape as get(). */
  async save(envId, chips, authenticatedFetch) {
    const response = await authenticatedFetch(
      `${API_URL}/api/environments/${envId}/welcome-chips`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chips }),
      }
    );
    return asJsonOrThrow(response, 'Failed to save welcome chips');
  }
}

const welcomeChipsService = new WelcomeChipsService();
export default welcomeChipsService;
